import { useState, useEffect } from 'react';
import {
  PolicyAPI,
  Policy
} from '../api';
export function usePolicies(workgroupId: number, applicationId?: number) {
  const [data, setData] = useState<Policy[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPolicies = async () => {
    try {
      setLoading(true);
      const response = await PolicyAPI.getAll(workgroupId);

      if (response.code === '200' && response.data) {
        setData(response.data);
      } else {
        setError(response.message || 'Failed to fetch policies');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (workgroupId || applicationId) {
      fetchPolicies();
    }
  }, [workgroupId, applicationId]);

  return { data, loading, error, refetch: fetchPolicies };
}
